<template>
    <div v-if="options_loaded && passed_filter && panel_required">
        <div class="designeroption spitfire-trimpacks-box" :data-designer-component-id="component_id">
            <h3 v-if="title">
              {{ title }}
              <designer-question-popup-info
                  v-if="has_popup_info"
                  :popup_info_title_html="popup_info_title_html"
                  :popup_info_inner_html="popup_info_inner_html"
              ></designer-question-popup-info>
            </h3>
            <div :id="'radio--' + component_id" class="spitfire-trimpacks-box-inner">
                <div v-if="options_loaded && passed_filter">
                    <div class="radiooption stylesoption" v-if="!loading">
                        <span v-for="option in filtered_option_list">
                            <label class="mr-3">
                                <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/> {{ option.label }}
                            </label>
                        </span>
                    </div>
                    <div class="info-box-text">
                        <div>
                            30mm wide flat aluminium trim, powder coated to match external frame colour
                        </div>
                        <div>
                            2 x overall height + 100mm
                        </div>
                        <div>
                            1 x overall width + 100mm
                        </div>
                    </div>
                    <div v-if="loading">
                        <p>Loading Options</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
  import DesignerQuestionTrimPacks from "../DesignerQuestionTrimPacks.vue";

  export default {
    mixins: [
        DesignerQuestionTrimPacks
    ],
  }
</script>
